"use client";

import type { PropsWithChildren } from "react";

import type { CompanyMetaContextValue } from "@/modules/homepage/api";
import { CompanyMetaContext } from "@/modules/homepage/api";
import { GoogleTagManager } from "@/services/analytics/gtm";
import { QueryClientProvider } from "@/services/http";

export interface ClientLayoutProps {
  readonly companyMeta: CompanyMetaContextValue;
}

export function Analytics() {
  return <GoogleTagManager />;
}

export function ClientLayout({ children, companyMeta }: PropsWithChildren<ClientLayoutProps>) {
  return (
    <>
      <Analytics />
      <QueryClientProvider>
        <CompanyMetaContext.Provider value={companyMeta}>{children}</CompanyMetaContext.Provider>
      </QueryClientProvider>
    </>
  );
}
